import styled from 'styled-components';

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SwitchInput = styled.input`
  width: 0;
  height: 0;
  opacity: 0;
  position: absolute;
`;

export const SwitchLabel = styled.label<{ disabled?: boolean }>`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const Slider = styled.span<{ checked?: boolean; disabled?: boolean }>`
  position: absolute;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ checked, disabled }) => {
    if (disabled) {
      return '#80808080'; // #808080 with 50% opacity
    }
    return checked ? '#298ee6' : '#808080';
  }};
  border-radius: 12px;
  transition: background 0.2s;

  &:before {
    content: '';
    position: absolute;
    left: 4px;
    top: 4px;
    width: 16px;
    height: 16px;
    background: white;
    border-radius: 50%;
    transition: transform 0.2s;
    transform: ${({ checked }) => (checked ? 'translateX(16px)' : 'none')};
  }
`;
